import cx from 'classnames'

type Props = {
  className?: string
  text: string
  backgroundColor?: string
}

const Tag = ({ className, text, backgroundColor }: Props) => {
  return (
    <span
      className={cx(
        className,
        'text-xs text-white py-1 px-2 rounded whitespace-nowrap',
        backgroundColor ? backgroundColor : 'bg-orange-500'
      )}
    >
      {text}
    </span>
  )
}

export default Tag
